import { render, staticRenderFns } from "./TabelaDeRecebimentosDeContasAReceber.vue?vue&type=template&id=6b4db432&scoped=true"
import script from "./TabelaDeRecebimentosDeContasAReceber.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaDeRecebimentosDeContasAReceber.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TabelaDeRecebimentosDeContasAReceber.vue?vue&type=style&index=0&id=6b4db432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4db432",
  null
  
)

export default component.exports